import React, { useReducer, useEffect } from 'react';
import { Box, Tooltip, TextField, IconButton } from '@mui/material';
import DefaultModal from '../../Utils/DefaultModal';
import { api } from '../../../services/api';
import ColorButton from '../../Buttons/ColorButton';
import { lockedReducer } from '../../Utils/reducers';
import MegaAutoComplete from '../../Utils/megautocomplete';
import validateData from './validateEmpresa';

const getTitle = (data) => {
    if (data?.id)
        return 'Editar'
    return 'Adicionar'
}

const submit = async (handleClose, data, setLoader, reloadData, setConsultas) => {
    setLoader(true)
    let res = null
    if (data.id)
        res = await api.patch(`/consulta_rename/${data.id}/`, data)
    else
        res = await api.post(`/consulta_rename/`, data)
    if (res.status === 200) {
        reloadData(setLoader, setConsultas)
        handleClose()
    }
    setLoader(false)
}

const loadRetrieve = async (id, setState, setLoader) => {

    setLoader(true)
    const res = await api.get(`/consulta_rename_empresa/${id}/`)
    if (res.status === 200) {
        setState({ empresa: res.data })
    }
    setLoader(false)
}

const EditRename = ({ data, handleClose, reloadData, setLoader, setConsultas }) => {

    const [state, setState] = useReducer(lockedReducer, {
        empresa: null,
        rename: '',
        ...data,
        id: data.id ? data.id : 0
    })

    const validTable = validateData(state)

    useEffect(() => {
        if (data.id)
            loadRetrieve(data.id, setState, setLoader)
    }, [setLoader, data.id])

    return (
        <>
            <DefaultModal
                dialogProps={{
                    sx: {
                        '& .MuiPaper-root': {
                            maxWidth: 'unset',
                            maxHeight: 'unset',
                            width: '30%',
                            height: state.id === 0 ? '40%' : '30%',
                            margin: '0px',

                            '@media (min-width: 1600px)': {
                                width: '80%', // Largura para telas maiores
                                height: '80%', // Altura para telas maiores
                            },
                        }
                    }
                }}
                handleClose={handleClose}
                open={true}
                title={`${getTitle(state)} renomeação de empresa `}
                content={
                    <Box className='item-content-modal noborder'>

                        {
                            state.id === 0 ? (
                                <Box className='item-profile-row'>
                                    <MegaAutoComplete
                                        id="renameEstoqueEmpresa"
                                        multiple={false}
                                        value={state.empresa}
                                        onChange={(data) => { setState({ empresa: data }) }}
                                        noOptionsText={'Digite para procurar uma empresa'}
                                        timeoutUrl='/consulta/filiais/'
                                        timeoutParam='label'
                                        label='Empresa'
                                    />
                                </Box>
                            ) : <></>
                        }

                        <Box className='item-profile-row'>
                            <TextField
                                id="renameText"
                                type="text"
                                label="Renomear"
                                size='small'
                                value={state.rename}
                                onChange={(e) => { setState({ rename: e.target.value }) }}
                                fullWidth={false}
                                sx={{ width: '100%' }}
                            />
                        </Box>

                    </Box>
                }

                action={

                    <Tooltip title={validTable} placement="left">
                        <span>
                            <ColorButton disabled={validTable} onClick={() => submit(handleClose, state, setLoader, reloadData, setConsultas)}>Salvar</ColorButton>
                        </span>
                    </Tooltip>

                }
            />

        </>
    )
}

export default EditRename